import Swiper, { A11y, Autoplay, EffectFade } from 'swiper';

import '../../sass/blocks/carousel.scss';

(() => {
    const $carousels = document.querySelectorAll('.carousel');

    if (!$carousels) return;

    $carousels.forEach($carousel => {
        const $carouselSlider = $carousel.querySelector('.carousel__slider');
        const $carouselSlides = $carousel.querySelectorAll('.carousel__slider .swiper-slide');

        if ($carouselSlides.length <= 1) return;

        const initCarousel = () => {
            if (!$carouselSlider) return;

            new Swiper($carouselSlider, {
                modules: [ A11y, Autoplay, EffectFade ],
                autoplay: {
                    delay: 3000,
                },
                effect: 'fade',
                allowTouchMove: false,
            });
        };

        initCarousel();
    });
})();
